import * as React from 'react';
import { IButton, IconButton } from '@fluentui/react/lib/Button';
import { default as PaneOpen } from 'owa-fluent-icons-svg/lib/icons/PaneOpenRegular';
import { default as PaneClose } from 'owa-fluent-icons-svg/lib/icons/PaneCloseRegular';
import { getIsLeftNavShown } from 'owa-calendar-layout';

import styles from './CalendarLeftPane.scss';

interface CalendarLeftPanelToggleButtonProps {
    onToggle: () => void;
    autoFocus: boolean;
}

export default function CalendarLeftPanelToggleButton(
    props: CalendarLeftPanelToggleButtonProps
): JSX.Element {
    const buttonRef = React.useRef<IButton>(null);

    React.useEffect(() => {
        if (props.autoFocus && buttonRef.current) {
            buttonRef.current.focus();
        }
    }, []);

    return (
        <IconButton
            className={styles.leftPaneToggleButton}
            iconProps={{
                iconName: getIsLeftNavShown() ? PaneOpen : PaneClose,
                styles: {
                    root: styles.leftPaneToggleIcon,
                },
            }}
            onClick={props.onToggle}
        />
    );
}
